// extracted by mini-css-extract-plugin
module.exports = {"contenedor":"styles_contenedor__3WoXy","header":"styles_header__UiOU6","scroll":"styles_scroll__4XSDV","footer":"styles_footer__Inf6m","closeButton":"styles_closeButton__bfoN6"};